import { QuoteOrderStatusKeys } from '@teinor/erp/types/company/order/quote/quoteOrder'
import useTwinTranslation from '../useTwinTranslation'

type MyStatusTy = Record<QuoteOrderStatusKeys, string>

const useQuoteStatus = () => {
    const {t} = useTwinTranslation()
    const quoteStatus: MyStatusTy = {
        0: t('waitingResponse', 'Esperando respuesta'),
        1: t('waitingResponse', 'Esperando respuesta'),
        2: t('sent', 'Enviado'),
        3: t('acceptedQuote', 'Presupuesto aceptado'),
        4: t('deniedQuote', 'Presupuesto cancelado'),
        5: t('processed', 'Procesado')
    }
    return { quoteStatus }
}

export default useQuoteStatus